import { Eye, Edit, Copy, Trash2, Tags } from "lucide-react";
import type { ActionItem } from "@/components/ui/actions-dropdown";
import type { ActionSurface } from "./types";

export interface ProfileActionsContext {
  surface: ActionSurface;
  onView: () => void;
  onEdit: () => void;
  onDuplicate: () => void;
  onAssignTags: () => void;
  onDelete: () => void;
}

const L = (s: ActionSurface, list: string, detail: string) =>
  s === "list" ? list : detail;

export function buildProfileActions(ctx: ProfileActionsContext): ActionItem[] {
  const { surface } = ctx;
  const items: ActionItem[] = [];
  if (surface === "list") {
    items.push({ label: "View", icon: Eye, onClick: ctx.onView });
  }
  items.push(
    { label: L(surface, "Edit", "Edit Profile"), icon: Edit, onClick: ctx.onEdit },
    { label: L(surface, "Duplicate", "Duplicate Profile"), icon: Copy, onClick: ctx.onDuplicate },
    { label: L(surface, "Assign Tags", "Assign Tags"), icon: Tags, onClick: ctx.onAssignTags },
    { label: L(surface, "Delete", "Delete Profile"), icon: Trash2, onClick: ctx.onDelete, destructive: true },
  );
  return items;
}
